import React from 'react'
import { Badge } from 'reactstrap'

const BadgeCode = ({ color, text }) => {
  return (
    <Badge color={color} style={{ marginInlineEnd: 12 }}>
      {text}
    </Badge>
  )
}

export default BadgeCode
